import type { Ref } from 'react';

/**
 * Merges multiple refs into a single callback ref.
 * Supports callback refs, ref objects, and null/undefined.
 */
export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): (instance: T | null) => void {
  return (instance: T | null) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(instance);
      } else if (ref) {
        ref.current = instance;
      }
    }
  };
}
